import { render } from "./SetShopPos.vue?vue&type=template&id=5693ef8d&scoped=true"
import script from "./SetShopPos.vue?vue&type=script&lang=js"
export * from "./SetShopPos.vue?vue&type=script&lang=js"

import "./SetShopPos.vue?vue&type=style&index=0&id=5693ef8d&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5693ef8d"]])

export default __exports__